enum BriefingCallStatus {
  Pending = 1,
  Scheduled = 2,
  Complete = 3,
}

export default BriefingCallStatus;
